// extracted by mini-css-extract-plugin
export default {"brandProducts":"Brand_brandProducts__ZCNrc","dmbrandPage":"Brand_dmbrandPage__pEyFu"};